import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import Co2Icon from '@mui/icons-material/Co2';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import { PriceDataList } from '../components/PriceData';
import { addDays, subDays } from 'date-fns';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`price-tabpanel-${index}`}
            aria-labelledby={`price-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ pt: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const PriceDataPage = () => {
    const [tabValue, setTabValue] = useState(0);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const navigate = useNavigate();

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handlePreviousDay = () => {
        const yesterday = subDays(selectedDate, 1);
        // Alleen toestaan als de datum niet voor 2024 is
        if (yesterday.getFullYear() >= 2024) {
            setSelectedDate(yesterday);
        }
    };

    const handleNextDay = () => {
        const tomorrow = addDays(selectedDate, 1);
        const maxDate = addDays(new Date(), 1); // Morgen
        // Alleen toestaan als de datum niet na morgen is
        if (tomorrow <= maxDate) {
            setSelectedDate(tomorrow);
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', mb: 2 }}>
                <Typography variant="h4" gutterBottom>
                    Prijsdata
                </Typography>
            </Box>


            
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabValue} onChange={handleTabChange}>
                    <Tab icon={<ElectricBoltIcon />} label="Stroomprijzen" iconPosition="start" />
                    <Tab icon={<Co2Icon />} label="CO2 Emissiefactor" iconPosition="start" />
                    <Tab icon={<LocalGasStationIcon />} label="Waterstofprijzen" iconPosition="start" />
                </Tabs>
            </Box>
            
            <TabPanel value={tabValue} index={0}>
                <Box sx={{ mb: 2 }}>
                    <Button 
                        variant="contained" 
                        startIcon={<AnalyticsIcon />}
                        onClick={() => navigate('/electricity-price')}
                        sx={{ mb: 2 }}
                    >
                        Gedetailleerde Stroomprijs Analyse
                    </Button>
                </Box>
                <PriceDataList 
                    activeChart="electricity" 
                    selectedDate={selectedDate} 
                    onDateChange={setSelectedDate}
                    onPreviousDay={handlePreviousDay}
                    onNextDay={handleNextDay}
                />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
                <PriceDataList 
                    activeChart="co2" 
                    selectedDate={selectedDate} 
                    onDateChange={setSelectedDate}
                    onPreviousDay={handlePreviousDay}
                    onNextDay={handleNextDay}
                />
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
                <Box sx={{ mb: 2 }}>
                    <Button 
                        variant="contained" 
                        startIcon={<AnalyticsIcon />}
                        onClick={() => navigate('/hydrogen-price')}
                        sx={{ mb: 2 }}
                    >
                        Gedetailleerde Waterstof Analyse
                    </Button>
                </Box>
                <PriceDataList 
                    activeChart="hydrogen" 
                    selectedDate={selectedDate} 
                    onDateChange={setSelectedDate}
                    onPreviousDay={handlePreviousDay}
                    onNextDay={handleNextDay}
                />
            </TabPanel>
        </Box>
    );
};

export default PriceDataPage; 